import React, { FunctionComponent, useMemo } from 'react';

import { Divider } from '@yandex-360/orb-components/dist/components/Divider';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import {
    selectHasSummarizationBanRolePermission,
    selectHasSummarizationSettingsPermission,
} from '../../../../../../pages/call/features/permissions';
import { selectIsSummarizationAvailable } from '../../../../../../pages/call/features/summarization';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../../features/flags/selectors';
import { i18n } from '../../../../../helpers/i18n';
import { isMobileUa } from '../../../../uatraits/selectors';
import { CalendarSummarizationSwitcher } from './calendar-summarization-mail-recipient-switcher';
import { CloudRecordingSwitcher } from './cloud-recording-switcher';
import { LocalRecordingSwitcher } from './local-recording-switcher';
import styles from './styles.css';
import { SummarizationMailRecipientSwitcher } from './summarization-mail-recipient-switcher';
import { SummarizationSwitcher } from './summarization-switcher';

export const PermissionsSection: FunctionComponent = () => {
    const isMobile = useSelector(isMobileUa);
    const isSummarizationAvailable = useSelector(selectIsSummarizationAvailable);
    const hasSummarizationSettingsPermission = useSelector(selectHasSummarizationSettingsPermission);
    const hasBanPermission = useSelector(selectHasSummarizationBanRolePermission);
    const calendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);
    const isSummarizationGroupNotEmpty = useMemo(() => {
        return isSummarizationAvailable && (hasSummarizationSettingsPermission || hasBanPermission);
    }, [hasBanPermission, hasSummarizationSettingsPermission, isSummarizationAvailable]);

    return (
        <>
            {!isMobile && <h3 className={styles.permissionsHeader}>{i18n('settings', 'permissions-header')}</h3>}
            <div className={styles.permissionsExplanation}>
                {calendarSummarizationFeatureEnabled
                    ? i18n('settings-v2', 'permissions-description-v2')
                    : i18n('settings', 'permissions-explanation')}
            </div>
            <div className={cn(styles.content, { [styles.mobile]: isMobile })}>
                {calendarSummarizationFeatureEnabled && (
                    <Text className={styles.groupTitle} typography="body-short-lg-regular">
                        {i18n('record', 'file-name-prefix')}
                    </Text>
                )}
                <LocalRecordingSwitcher />
                <CloudRecordingSwitcher />
                {calendarSummarizationFeatureEnabled && isSummarizationGroupNotEmpty && (
                    <>
                        <Divider />
                        <Text className={styles.groupTitle} typography="heading-xs">
                            {i18n('settings-v2', 'meeting-summarization-v2')}
                        </Text>
                    </>
                )}
                <SummarizationSwitcher />
                <SummarizationMailRecipientSwitcher />
                <CalendarSummarizationSwitcher />
            </div>
        </>
    );
};
